function SubmitBar({ onSubmit, disabled = false, isSubmitting = false }) {
  return (
    <div className="photo-select-submit-bar" data-node-id="6359:21793">
      <button
        className="photo-select-submit"
        onClick={onSubmit}
        type="button"
        disabled={disabled || isSubmitting}
      >
        {isSubmitting ? "제작 요청 중" : "제작 요청하기"}
      </button>
    </div>
  );
}

export { SubmitBar };
